<template>
  <div>
    <div style="font-size: 16px; font-weight: bold; ">
      {{ this.translate('ui_section_financing__equityorloan')}}
    </div>
    <div style="display: flex; gap: 20px;">
      <div
        style="flex: 1 1 0;"
      >
        <v-radio-group v-model="selectedFinancingType" @change="onChangeFinancingType">
          <v-radio
            data-qa="section_financing__equityorloan_loan"
            :value="radioGroupItems[0].value"
            :label="radioGroupItems[0].name"
            name="financing"
          >
          </v-radio>
        </v-radio-group>
        <div
          style="line-height: 1.5;"
          v-html="radioGroupItems[0].help">
        </div>
      </div>

      <div
        style="flex: 1 1 0;"
        elevation="1"
      >
        <v-radio-group v-model="selectedFinancingType" @change="onChangeFinancingType">
          <v-radio
            data-qa="section_financing__equityorloan_equity"
            :value="radioGroupItems[1].value"
            :label="radioGroupItems[1].name"
            name="financing"
          >
          </v-radio>
        </v-radio-group>
        <div
          style="line-height: 1.5;"
          v-html="radioGroupItems[1].help">
        </div>
      </div>
    </div>
    <div class="dialog-resource-name-and-formula">
      <v-text-field
        data-qa="dialog_resource_add__edit_name_input"
        v-model="dialogConfig.resource.coreResource.name"
        label="Name"
        required
        ref="resourceName"
        outlined
        dense
        background-color="white"
      ></v-text-field>
    </div>

    <DialogResourceAddFlow
      :flow="dialogConfig.resource.flows[0]"
      :name="this.translate('ui_section_financing__findraw')"
      :flowIndex=0
      :formulasAvailable="getFormulasAvailable(dialogConfig.resource.flows[0])"
      :updateAssumptions="updateAssumptions"
      :dialogConfig="dialogConfig"
      :dialogFormula="dialogFormula"
      :onFormulaChange="onFormulaChange"
    />

    <DialogResourceAddFlow
      :flow="dialogConfig.resource.flows[1]"
      :name="this.translate('ui_section_financing__finrepay')"
      :flowIndex=1
      :formulasAvailable="getFormulasAvailable(dialogConfig.resource.flows[1])"
      :updateAssumptions="updateAssumptions"
      :dialogConfig="dialogConfig"
      :dialogFormula="dialogFormula"
      :onFormulaChange="onFormulaChange"
    />

    <div
      v-if="dialogConfig.resource.coreResource.rel === 'loan'"
      style="display: flex; font-size: 16px;"
    >
      <div style="color: #000; width: 150px;">
        {{ this.translate('ui_section_financing__rate') }}
      </div>
      <div style="width: 100px; color: #000; text-align: right;">
        {{ this.translate('ui_section_financing__rate_units') }}
      </div>
      <v-text-field
        data-qa="dialog_resource__assumptions_input"
        v-model="dialogConfig.resource.otherAssumptions.interestmargin.value"
        required
        style="align-items: center; padding-left: 20px;"
        outlined
        dense
        background-color="white"
      ></v-text-field>
    </div>

    <div
      v-if="dialogConfig.resource.coreResource.rel === 'equity'"
      style="display: flex; font-size: 16px;"
    >
      <div style="color: #000; width: 150px;">
        {{ this.translate('ui_section_financing__dividend') }}
      </div>
      <div style="width: 100px; color: #000;">
        {{ this.translate('ui_section_financing__dividend_units') }}
      </div>
      <v-text-field
        data-qa="dialog_resource__assumptions_input"
        v-model="dialogConfig.resource.otherAssumptions.dividend.value"
        required
        style="align-items: center; padding-left: 20px;"
        outlined
        dense
        background-color="white"
      ></v-text-field>
    </div>
  </div>
</template>

<script>

import Mixin from '@/mixins/mixin';
import DialogResourceAddFlow from '@/components/dialogs/DialogResourceAdd/DialogResourceAddFlow';

export default {
  components: {
    DialogResourceAddFlow,
  },
  mixins: [Mixin],
  data() {
    return {
      radioGroupItems: [{
        value: 'loan',
        name: this.translate('ui_section_financing__loan'),
        help: this.translate('ui_section_financing__loan_help'),
      }, {
        value: 'equity',
        name: this.translate('ui_section_financing__equity'),
        help: this.translate('ui_section_financing__equity_help'),
      }],
      e1: 1,
    };
  },
  props: {
    formulas: Array,
    updateAssumptions: Function,
    dialogConfig: Object,
    dialogFormula: Object,
  },
  computed: {
    selectedFinancingType: {
      get() {
        return this.dialogConfig.resource.coreResource.rel;
      },
      set(rel) {
        if (rel === 'loan') {
          this.dialogConfig.resource.otherAssumptions.interestmargin = {
            name: 'input_resource_options_interestmargin',
            value: null,
            units: 'percent',
          };
        } else {
          delete this.dialogConfig.resource.otherAssumptions.interestmargin;
        }
        this.dialogConfig.resource.coreResource.rel = rel;
        // eslint-disable-next-line
        const nextResourceIndex = this.getSectionResourcesByRel(rel).length + 1;

        // // borrowed from TemplateEditor
        const nameTranslated = `${this.translate(rel)} ${nextResourceIndex}`;
        const name = nameTranslated.charAt(0).toUpperCase() + nameTranslated.slice(1);
        // end borrowed

        // const resourceName = `New ${rel} ${nextResourceIndex}`;
        this.dialogConfig.resource.coreResource.name = name;
      },
    },
  },
  methods: {
    onChangeFinancingType(value) {
      this.$emit('onChangeFinancingType', value);
    },
    getFormulasAvailable(flow) {
      const { rel } = this.dialogConfig.resource.coreResource;
      // eslint-disable-next-line
      const formulas = this.formulas.filter((f) => {
        const isAllowedForFlow = f.flows ? f.flows.includes(flow.id) : true;
        return f.allowedRels.includes(rel) && isAllowedForFlow;
      });
      return formulas;
    },
  },
};
</script>
